export enum InputTypeE {
    TEXT = "text",
    EMAIL = "email",
    NUMBER = "number",
    DATE = "date",
    PASSWORD = "password",
    DATETIME = "datetime-local",
}

interface FFieldI {
    formName: string;
    label: string | React.ReactNode;
    labelAppend?: string | React.ReactNode | null;
    required?: boolean;
    onBlur?: (v: any) => void;
    type?: InputTypeE;
    tabIndex?: number;
    id?: string;
    onChange?: (v: any) => void;
    autoFocus?: boolean;
    min?: number;
    max?: number;
    className?: string;
    floating?: boolean;
}

export interface OptionI {
    label: string;
    value: string | number | undefined;
}

export interface FFieldInputI extends FFieldI {}

export interface FFieldCheckboxI extends FFieldI {
    options: OptionI[] | undefined;
}

export interface FFieldSelectI extends FFieldI {
    options: OptionI[] | undefined;
}
